import { Component, OnInit, DOCUMENT } from '@angular/core';
import { Renderer2, Inject } from '@angular/core';

import {environment} from '../environments/environment';
import { AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements AfterViewInit, OnInit {
  title = 'Fair Way Golf';
  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const loader = this.renderer.selectRootElement('#preloader');
    this.renderer.setStyle(loader, 'display', 'none');
  }
}
